import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { injectIntl as withIntl } from 'react-intl';

import getShopId from '@core/reducers/shop/selectors/getShopId';
import getIsOccasionPickup from '@core/reducers/shop/selectors/getIsOccasionPickup';

import trackShopReviewsLoaded from '@conversion/tracking/actions/trackShopReviewsLoaded';
import { getIsDesktopLayout } from '@shared/selectors';

import { goBack } from '@shared/actions';
import { fetchReviews, cleanState } from './actions';
import {
  getIsFetchingReviews,
  getReviews,
  getReviewsCount,
  getTotal,
} from './selectors';

const mapStateToProps = createStructuredSelector({
  shopId: getShopId,
  isFetchingReviews: getIsFetchingReviews,
  reviews: getReviews,
  reviewsCount: getReviewsCount,
  total: getTotal,
  isDesktopLayout: getIsDesktopLayout,
  isPickup: getIsOccasionPickup,
});

const mapDispatchToProps = {
  fetchReviews,
  cleanState,
  trackShopReviewsLoaded,
  goBack,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withIntl);
